import config from 'src/config/config';
import api from 'src/api/interceptor';

export function getVehicleListApi(
  tenantOrganisationId,
  pageNumber,
  searchInput,
  tableSortOrder,
  tableSortField,
  tableFieldFilter,
  paginationBatchSize,
  queryString,
) {
  const params = new URLSearchParams(queryString);

  tableFieldFilter?.forEach((fieldId) => params.append('field_id', fieldId));

  return api
    .get(
      `${config.test_url}api/vehicle-tracking/get-vehicle-master-list/?${params.toString()}`,
      {
        params: {
          tenant_organisation_id: tenantOrganisationId,
          page_number: pageNumber,
          search_term: searchInput || null,
          sort_order: tableSortOrder,
          sort_field: tableSortField,
          pagination_batch_size: paginationBatchSize,
        },
      },
    )
    .then((res) => Promise.resolve(res));
}

export function getVehicleLocationLogsApi(
  tenantOrganisationId,
  vehicleId,
  filters = {},
) {
  const params = {
    tenantOrganisationId,
    vehicleId,
    ...filters,
  };

  return api
    .get(`${config.test_url}api/vehicle-tracking/get-vehicle-location-logs/`, {
      params,
    })
    .then((res) => Promise.resolve(res));
}

export function createVehicleLocationLogsApi(data) {
  return api
    .post(
      `${config.test_url}api/vehicle-tracking/create-vehicle-location-logs/`,
      data,
    )
    .then((res) => Promise.resolve(res));
}

export function createPODAttachmentsForVehicleTrackingApi(formData) {
  return api
    .post(
      `${config.test_url}api/vehicle-tracking/create-pod-attachments-for-vehicle-tracking/`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    )
    .then((res) => Promise.resolve(res));
}

export function getPODAttachmentsForVehicleTrackingApi(vehicleTrackingNumber) {
  return api
    .get(
      `${config.test_url}api/vehicle-tracking/get-pod-attachments-for-vehicle-tracking/`,
      {
        params: {
          vehicleTrackingNumber,
        },
      },
    )
    .then((res) => Promise.resolve(res));
}
